<template>
  <div class="public-order" ref="public-order">
    <form
      class="form form_w660 form_pa30 form_m_pa16 public-order_form"
      @submit.prevent="save"
      v-if="isMain"
      ref="main-form"
    >
      <div class="form-item form-item_flex form-item_between mb12 flex-pub-m-column">
        <div class="form-item_half_pub mb24_pub_m">
          <el-input
            class="form-item__first-name"
            :placeholder="$t('forms.firstName')"
            v-model="request.contact.first_name"
            :class="{
             'error-input': $v.request.contact.first_name.$anyError && !$v.request.contact.first_name.required 
            }"
          />
        </div>

        <div class="form-item_half_pub">
          <el-input
            :placeholder="$t('forms.lastName')"
            v-model="request.contact.last_name"
            :class="{
             'error-input': $v.request.contact.last_name.$anyError && !$v.request.contact.last_name.required 
            }"
          />
        </div>
      </div>

      <div class="form-item mb12 form-item_resize-none">
        <el-input
          type="textarea"
          :rows="5"
          :placeholder="$t('forms.description')"
          v-model="request.description"
          ref="description"
        ></el-input>
      </div>

      <upload-image @onChange="filesUploaded" />

      <div class="form-item form-item_flex mb12">
        <el-select
          v-model="request.service_id"
          :placeholder="$t('forms.selectService')"
          @change="loadWorkload"
          :class="{
             'error-input': $v.request.service_id.$anyError && !$v.request.service_id.required 
            }"
        >
          <el-option
            v-for="item in services"
            :key="item.value"
            :label="$t(`services.${item.slug}`)"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>

      <div class="form-item form-item_flex form-item_between mb12 flex-pub-m-column">
        <div class="form-item_half_pub mb24_pub_m">
          <el-date-picker
            v-model="request.date"
            type="date"
            :placeholder="$t('forms.pickADay')"
            format="dd/MM/yyyy"
            @change="changeTime"
            :pickerOptions="pickerOptions"
            :editable="false"
            ref="datepicker"
            :class="{
             'error-input': $v.request.date.$anyError && !$v.request.date.required 
            }"
          ></el-date-picker>
        </div>

        <div class="form-item_half_pub">
          <el-select
            v-model="request.time"
            :placeholder="$t('forms.chooseTime')"
            :class="{
             'error-input': $v.request.time.$anyError && !$v.request.time.required 
            }"
          >
            <el-option v-for="item in timeOptions.current" :key="item.id" :value="item.time">
              <span>
                {{ item.time }}
                <span style="font-weight: bold; margin-left: 8px;">
                  {{
                  getPrice(item)
                  }}
                </span>
              </span>
            </el-option>
          </el-select>
        </div>
      </div>

      <div class="form-item form-item_flex mb12">
        <autocomplete-input
          :class="{
             'error-input': ($v.request.address.$anyError && !$v.request.address.required ) || ($v.request.address.$dirty && filledAddressWithError)
            }"
          :placeholder="$t('forms.street')"
          :geolocation="false"
          @fill="fill"
          @errorInput="errorInput"
        />
      </div>

      <div class="form-item form-item_flex form-item_between mb12 flex-pub-m-column">
        <div class="form-item_half_pub mb24_pub_m">
          <el-input
            :placeholder="$t('forms.email')"
            v-model="request.contact.email"
            :class="{
             'error-input': $v.request.contact.email.$anyError && !$v.request.contact.email.required 
            }"
          />
        </div>

        <div class="form-item_half_pub">
          <vue-tel-input
            v-model="request.contact.phone"
            @validate="checkValue"
            :placeholder="$t('forms.phone')"
            :inputOptions="{ showDialCode: true }"
            mode="international"
            :class="{
             'vue-error-input': (($v.request.contact.phone.$anyError && !$v.request.contact.phone.required) || ($v.request.contact.phone.$dirty && !isValidPhone ))
            }"
          ></vue-tel-input>
        </div>
      </div>

      <div class="form-item mb12">
        <p class="form-item__text form-item__text_foz12">
          {{$t('forms.privacyTextPart1')}}
          <a
            :href="privacyPolicy"
            target="_blank"
            class="form-item__link"
          >{{$t('forms.privacyLink1')}}</a>
          {{$t('forms.privacyAnd')}}
          <a
            :href="termsOfViews"
            target="_blank"
            class="form-item__link"
          >{{$t('forms.privacyLink2')}}</a>
          {{$t('forms.privacyTextPart2')}}
        </p>
      </div>

      <div class="form-item mb16">
        <div>
          <input class="form-item__checkbox" type="checkbox" id="rules-confirm" v-model="agree" />
          <label
            class="form-item__checkbox-label"
            for="rules-confirm"
            :class="{
            'form-item__checkbox-label_error': $v.agree.$anyError && !$v.agree.required 
          }"
          >
            <span class="form-item__text_foz12 form-item__text_usn">
              {{
              $t("forms.agreeSub")
              }}
            </span>
          </label>
        </div>
      </div>

      <div class="form-item mb12">
        <div>
          <input
            class="form-item__checkbox"
            type="checkbox"
            id="rules-confirm2"
            v-model="marketing"
          />
          <label class="form-item__checkbox-label" for="rules-confirm2">
            <span class="form-item__text_foz12 form-item__text_usn">
              {{
              $t("forms.yesGetEmails")
              }}
            </span>
          </label>
        </div>
      </div>

      <div class="form-item">
        <button
          class="btn btn_width btn_mobile-width-100 public-order__btn"
          :disabled="isSubmitted"
          :class="{
            btn_disabled: isSubmitted,
          }"
        >
          <div class="loader" v-if="isSubmitted"></div>
          {{ $t("buttons.create") }}
        </button>
      </div>
    </form>

    <form class="form form_pa30 form_m_pa16 public-order_form" v-if="isVerifyingCode">
      <div class="form-item form-item_flex mb12">
        <el-input
          minlength="4"
          maxlength="4"
          v-model="request.code"
          :placeholder="$t('forms.verifyInputTitle')"
          @input="verifyCode"
        />
      </div>

      <div class="form-item form-item_flex mb12" v-if="isError">
        <p style="font-size:14px">{{$t('forms.publicCode')}}</p>
      </div>

      <div class="form-item">
        <template v-if="!isVerified">
          <a
            :disabled="!isVerified"
            :class="{
            btn_disabled: !isVerified,
          }"
            target="_blank"
            class="btn btn_width btn_mobile-width-100 order-modal__btn"
            ref="link"
          >{{$t('forms.thankULink')}}</a>
        </template>
        <template v-else>
          <a
            :href="toCabinetLink"
            target="_blank"
            class="btn btn_width btn_mobile-width-100 order-modal__btn"
            ref="link"
            @click="changeView"
          >{{$t('forms.thankULink')}}</a>
        </template>
      </div>
    </form>

    <div class="thank-you" v-if="isThankUPage">
      <div class="thank-you__head">
        <p class="thank-you__title">{{$t('forms.thankUTitle')}}</p>
        <p class="thank-you__text">{{$t('forms.thankUText')}}</p>
      </div>
      <div class="thank-you__link">
        <a :href="toCabinetLink" target="_blank" ref="link">{{$t('forms.thankULink')}}</a>
      </div>
      <div class="thank-you__img">
        <svg
          width="300"
          height="300"
          viewBox="0 0 215 270"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="Group 66">
            <path
              id="Stroke 1"
              d="M60.3347 181.529C-9.18881 225.092 20.7136 147.572 20.7136 147.572"
              stroke="#F07300"
              stroke-width="22"
              stroke-linecap="round"
            />
            <g id="Group 5">
              <mask
                id="mask0"
                style="mask-type:alpha"
                maskUnits="userSpaceOnUse"
                x="5"
                y="107"
                width="32"
                height="43"
              >
                <path
                  id="Clip 4"
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M18.5426 107.149C16.7014 107.628 15.598 109.504 16.0772 111.341L17.603 117.201L14.8997 112.586C13.9396 110.946 11.8365 110.394 10.1872 111.354C8.54444 112.314 7.99356 114.419 8.95204 116.058L11.6117 121.187C9.80841 118.665 8.52468 118.723 7.15531 119.518C5.51256 120.478 4.96086 122.583 5.91934 124.223L10.1872 131.504C8.91251 133.778 7.5308 137.573 6.66043 143.961C11.5549 147.175 17.1699 149.126 23.0064 149.642L23.4634 149.682C23.3481 148.74 23.3473 147.73 23.4897 146.623C23.7079 144.936 24.3568 143.478 25.1078 142.282C31.5124 141.327 36.3822 135.78 36.3205 129.18C36.304 127.362 34.9634 125.761 33.1486 125.623C31.0793 125.466 29.3797 127.121 29.43 129.137C29.5197 132.597 28.4394 134.75 24.9637 134.83C21.5077 134.91 18.6191 132.095 18.5483 128.646C18.48 125.241 19.5661 123.123 22.9973 123.035C24.6343 122.994 26.1972 123.58 27.4035 124.686C28.884 126.052 31.2531 125.866 32.4989 124.208C33.6007 122.741 33.2523 120.67 31.8772 119.455C29.7898 117.612 27.2108 116.505 24.4671 116.235L22.7421 109.61C22.3394 108.062 20.9387 107.036 19.4113 107.036C19.1247 107.036 18.8332 107.072 18.5426 107.149Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask0)">
                <path
                  id="Fill 3"
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M21.4204 101.437L-9.87988 123.314L14.469 158.02L45.7677 136.143L21.4204 101.437Z"
                  fill="#2D2D2D"
                />
              </g>
            </g>
            <g id="Group 64">
              <path
                id="Fill 6"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2.26959 151.22L25.0792 165.525C27.3443 166.947 30.3347 166.263 31.7573 164L61.0603 110.974C62.222 109.125 61.6633 106.684 59.8125 105.523L41.1771 93.8347C39.3255 92.6733 36.8815 93.2314 35.7198 95.0813L0.742825 144.548C-0.68057 146.811 0.00282347 149.8 2.26959 151.22Z"
                fill="#502D8C"
              />
              <path
                id="Fill 8"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5.78099 148.848L26.9719 162.139C28.621 163.174 30.7975 162.676 31.8328 161.028L60.1367 110.115C60.9825 108.769 60.5756 106.993 59.2276 106.147L41.9147 95.2882C40.5668 94.4431 38.789 94.8497 37.9432 96.1955L4.67017 143.991C3.63482 145.64 4.13198 147.814 5.78099 148.848Z"
                fill="#BEB4DC"
              />
              <g id="Group 12">
                <mask
                  id="mask1"
                  style="mask-type:alpha"
                  maskUnits="userSpaceOnUse"
                  x="41"
                  y="188"
                  width="133"
                  height="82"
                >
                  <path
                    id="Clip 11"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M41.0679 188.099H173.254V269.052H41.0679V188.099Z"
                    fill="white"
                  />
                </mask>
                <g mask="url(#mask1)">
                  <path
                    id="Fill 10"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M173.051 269.053C174.486 259.025 167.862 188.099 167.886 188.099L41.0679 188.457C41.3353 215.423 41.7824 242.216 43.6431 269.053H173.051Z"
                    fill="#F07300"
                  />
                </g>
              </g>
              <path
                id="Fill 13"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M169.945 208.456C167.32 182.123 160.871 120.618 158.895 93.5307C158.196 83.9651 153.04 22.4333 145.982 23.3021C140.039 24.0348 130.983 39.2803 123.751 57.382C123.722 57.0329 60.5468 62.7439 60.5468 62.7439C55.3824 55.4896 40.0548 28.6025 31.6014 31.5506C19.3528 35.8224 37.1752 171.189 41.4183 216.988L169.945 208.456Z"
                fill="#F07300"
              />
              <path
                id="Fill 15"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M90.3618 22.5294C90.4159 22.9867 89.3592 23.4883 88.0015 23.6506C86.6437 23.8121 85.4984 23.5744 85.4435 23.1179C85.3885 22.6605 86.446 22.1589 87.8037 21.9966C89.1615 21.8335 90.3068 22.072 90.3618 22.5294Z"
                fill="#1D1818"
              />
              <path
                id="Fill 17"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M64.3452 63.9387C63.277 63.8871 61.6978 63.7879 60.6903 63.7232C60.1694 63.6904 59.7887 63.2281 59.8437 62.7085C60.0594 60.6496 59.9273 59.1842 59.9183 57.2729C59.9101 55.0796 60.3564 49.9259 61.8093 46.3164C62.6347 44.2641 63.4428 42.652 63.9867 41.6438C64.3846 40.9054 64.6061 40.094 64.6816 39.2588C64.9375 36.4172 66.6029 31.1931 72.2186 28.3958C78.2313 25.4009 84.8528 24.2076 87.5683 23.0987C87.949 22.9421 88.3657 22.8921 88.7653 22.9896C89.7005 23.2167 90.6473 23.0519 92.2569 23.0167C94.1881 22.9757 103.929 23.8601 108.377 25.9796C112.825 28.0982 113.422 30.4554 114.756 32.184C116.089 33.9117 117.053 35.614 118.221 39.2875C119.388 42.9609 122.057 47.8269 122.648 51.4914C123.031 53.8674 123.44 55.9992 123.68 57.2057C123.807 57.8433 123.459 58.4761 122.856 58.7236C121.514 59.2743 119.874 59.7456 119.874 59.7456C112.044 56.4705 100.291 55.9484 91.4783 56.6139C82.6656 57.2794 70.2529 59.7841 64.3452 63.9387Z"
                fill="#1D1818"
              />
              <path
                id="Fill 19"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M66.7061 45.9305C65.1129 37.3886 68.9048 30.8531 73.5122 27.7837C73.0798 27.9804 72.6467 28.1828 72.2184 28.3951C66.6036 31.1932 64.9365 36.4174 64.6814 39.259C64.6059 40.0941 64.3852 40.9047 63.9873 41.644C63.4426 42.6521 62.6345 44.2643 61.8084 46.3166C60.3562 49.9261 59.9099 55.0798 59.9198 57.2722C59.9264 59.1844 60.0601 60.6498 59.8427 62.7087C59.7877 63.2275 60.1692 63.6906 60.6901 63.7233C61.6984 63.7881 63.2769 63.8864 64.345 63.9389C64.77 63.6397 65.2319 63.3504 65.7208 63.0685C66.4042 60.7736 68.1607 53.7283 66.7061 45.9305Z"
                fill="#97CC62"
              />
              <path
                id="Fill 21"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M123.68 57.2048C123.44 55.9992 123.031 53.8674 122.648 51.4905C122.056 47.8261 119.388 42.9609 118.222 39.2882C117.054 35.6148 116.088 33.9108 114.755 32.1839C113.422 30.4554 112.825 28.0974 108.377 25.9779C107.82 25.7131 107.18 25.4664 106.482 25.2402C110.887 27.6818 114.938 32.9388 115.579 40.4013C116.227 47.9343 116.411 55.5967 117.807 58.9817C118.517 59.2194 119.215 59.4694 119.873 59.7448C119.873 59.7448 121.512 59.2743 122.855 58.7243C123.458 58.4768 123.806 57.8433 123.68 57.2048Z"
                fill="#97CC62"
              />
              <path
                id="Fill 23"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M100.574 56.3829C100.308 53.252 100.033 50.1851 99.8818 48.123C99.7899 46.8591 99.109 38.7295 98.1754 38.8442C97.3902 38.9409 96.1933 40.9555 95.2383 43.3471C95.2351 43.3004 86.8875 44.0553 86.8875 44.0553C86.2049 43.0971 84.1802 39.5442 83.0628 39.9343C81.8584 40.3539 82.8322 50.0703 83.6526 57.6607L100.574 56.3829Z"
                fill="#F07300"
              />
              <path
                id="Fill 25"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M85.4481 51.6341L82.5496 51.8529C82.4962 51.8562 82.4569 51.9029 82.4602 51.957C82.4643 52.0103 82.511 52.0496 82.5643 52.0455L85.4628 51.8267C85.5153 51.8226 85.5555 51.7767 85.5514 51.7234C85.5473 51.6693 85.5006 51.6292 85.4481 51.6341Z"
                fill="#111111"
              />
              <path
                id="Fill 27"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M85.4137 52.2752L82.6875 53.2816C82.6374 53.2997 82.6112 53.3546 82.6292 53.4054C82.6456 53.4472 82.6867 53.4718 82.7285 53.4685C82.7375 53.4685 82.7457 53.4661 82.7548 53.462L85.481 52.4571C85.531 52.4383 85.5564 52.3825 85.5376 52.3325C85.5195 52.2817 85.4637 52.2571 85.4137 52.2752Z"
                fill="#111111"
              />
              <path
                id="Fill 29"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M100.02 46.134C99.9938 46.0873 99.9347 46.07 99.888 46.0963L97.3447 47.5011C97.298 47.5265 97.2807 47.5855 97.3062 47.633C97.3267 47.6666 97.3628 47.6855 97.3997 47.683C97.412 47.6814 97.426 47.6773 97.4391 47.6707L99.9823 46.2651C100.029 46.2397 100.045 46.1815 100.02 46.134Z"
                fill="#111111"
              />
              <path
                id="Fill 31"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M100.548 48.0884H100.547L97.7091 48.354C97.6566 48.3589 97.6164 48.4064 97.6221 48.4589C97.6262 48.513 97.6722 48.5515 97.7255 48.5482L97.728 48.5474L100.565 48.281C100.618 48.2761 100.658 48.2286 100.653 48.1753C100.647 48.1228 100.6 48.0843 100.548 48.0884Z"
                fill="#111111"
              />
              <path
                id="Fill 33"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M94.8426 50.8794C94.7918 50.8622 94.7368 50.8885 94.7187 50.9384C94.4332 51.7433 93.8171 52.2129 93.0706 52.1949C92.2715 52.1769 91.6775 51.6408 91.36 51.022C91.9638 50.8417 92.0172 50.2065 92.018 50.0057C92.0188 49.9713 91.9909 49.9443 91.9565 49.9451C91.7317 49.9541 90.9014 50.009 90.1163 50.3319C90.0761 50.3492 90.0621 50.3975 90.0859 50.4336C90.2106 50.609 90.5782 51.0565 91.0876 51.0622C91.1492 51.6392 90.967 52.1916 90.5815 52.54C90.241 52.8489 89.8045 52.9268 89.3861 52.7539C89.3361 52.7334 89.2803 52.7571 89.259 52.8071C89.2393 52.8555 89.2623 52.9121 89.3123 52.9334C89.5158 53.0161 89.7217 53.0497 89.9227 53.035C90.2065 53.0137 90.4781 52.8948 90.7119 52.6834C91.0827 52.3465 91.287 51.8441 91.2927 51.304C91.6956 51.9564 92.3519 52.3719 93.0656 52.3891C93.9016 52.4088 94.5867 51.89 94.9017 51.0032C94.9189 50.9532 94.8935 50.8975 94.8426 50.8794Z"
                fill="#111111"
              />
              <path
                id="Fill 35"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M93.2698 48.8463C93.4593 48.8266 93.5963 48.6586 93.5774 48.4685C93.5594 48.28 93.3895 48.1423 93.2009 48.1619C93.0122 48.1808 92.8735 48.3504 92.8924 48.5389C92.9113 48.7275 93.0811 48.8651 93.2698 48.8463Z"
                fill="#111111"
              />
              <path
                id="Fill 37"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M89.3298 49.2554C89.3298 49.2136 89.3035 49.1768 89.2641 49.1628L87.3772 48.4965C87.3272 48.4793 87.2714 48.5055 87.2542 48.5555C87.2353 48.6055 87.2616 48.6612 87.3124 48.6793L88.9319 49.2505L87.3936 49.7529C87.3428 49.7702 87.3149 49.8242 87.3313 49.8759C87.3461 49.9193 87.3879 49.9456 87.4314 49.9415C87.4388 49.9415 87.447 49.9398 87.4543 49.9382L89.2633 49.3456C89.3027 49.3341 89.329 49.2964 89.3298 49.2554Z"
                fill="#111111"
              />
              <path
                id="Fill 39"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M119.874 59.7454C112.044 56.4702 100.291 55.9481 91.479 56.6137C82.6654 57.2792 70.2536 59.7839 64.3451 63.9385C64.3385 63.9385 64.3295 63.9376 64.3221 63.9376C63.9587 67.4759 63.3819 73.7876 65.5511 74.8482C67.931 76.0096 79.6078 67.5521 92.8056 66.5563C108.355 65.3818 119.159 72.5353 121.479 70.7772C123.615 69.1602 120.864 61.978 119.932 59.7282C119.897 59.738 119.874 59.7454 119.874 59.7454Z"
                fill="#292121"
              />
              <path
                id="Stroke 41"
                d="M203.054 44.2378C203.054 44.2378 207.626 68.2629 187.429 102.304C177.318 119.346 150.065 136.533 150.065 136.533"
                stroke="#F07300"
                stroke-width="22"
                stroke-linecap="round"
              />
              <g id="Group 45">
                <mask
                  id="mask2"
                  style="mask-type:alpha"
                  maskUnits="userSpaceOnUse"
                  x="175"
                  y="0"
                  width="39"
                  height="43"
                >
                  <path
                    id="Clip 44"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M175.693 0H213.217V42.7491H175.693V0Z"
                    fill="white"
                  />
                </mask>
                <g mask="url(#mask2)">
                  <path
                    id="Fill 43"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M183.905 6.44141L186.479 15.2759L182.692 10.6845C181.305 9.00103 178.814 8.75925 177.133 10.1468C175.448 11.5303 175.208 14.017 176.594 15.7005C177.857 17.2323 179.12 18.765 180.384 20.2968C181.943 22.1885 183.712 24.2891 185.031 26.3021C183.549 26.3791 181.986 26.1791 180.498 26.0775C178.339 25.9308 176.345 27.4643 176.134 29.6141C175.916 31.8393 177.581 33.7908 179.797 33.9408L189.374 34.753C190.502 37.447 190.502 37.447 191.454 42.7482L213.217 38.7158C212.402 35.2579 210.899 26.893 210.497 24.6579C209.544 19.3567 209.118 18.415 210.165 13.9072L211.185 9.51083C211.673 7.4069 210.476 5.19561 208.383 4.64566C206.218 4.07767 204.027 5.40707 203.526 7.56918L202.275 12.9556L201.385 3.57361C201.18 1.40412 199.253 -0.18837 197.081 0.016531C194.91 0.223891 193.313 2.1475 193.52 4.31863L194.487 14.5219L191.444 4.07685C190.824 1.9467 188.562 0.737783 186.432 1.42625C184.373 2.09095 183.301 4.36781 183.905 6.44141Z"
                    fill="#1D1818"
                  />
                </g>
              </g>
              <path
                id="Fill 46"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M46.21 122.249L23.9599 124.126C23.5497 124.16 23.2453 124.52 23.2806 124.93C23.3151 125.34 23.6744 125.643 24.0846 125.609L46.3355 123.732C46.7449 123.697 47.0493 123.337 47.0148 122.928C46.9795 122.518 46.6202 122.215 46.21 122.249Z"
                fill="#2D2D2D"
              />
              <path
                id="Fill 48"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M45.9895 127.18L25.1128 135.093C24.728 135.239 24.5344 135.668 24.6796 136.053C24.801 136.371 25.116 136.557 25.4385 136.53C25.5066 136.525 25.5738 136.51 25.6403 136.484L46.5187 128.571C46.9026 128.426 47.0962 127.996 46.951 127.612C46.805 127.228 46.3726 127.034 45.9895 127.18Z"
                fill="#2D2D2D"
              />
              <path
                id="Fill 50"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M145.494 79.0069C145.292 78.6488 144.837 78.5209 144.48 78.7242L125.035 89.6913C124.676 89.8937 124.55 90.347 124.752 90.7051C124.9 90.9666 125.182 91.1051 125.464 91.0805C125.567 91.0723 125.67 91.042 125.766 90.9871L145.212 80.02C145.57 79.8183 145.696 79.3651 145.494 79.0069Z"
                fill="#2D2D2D"
              />
              <path
                id="Fill 52"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M149.69 93.988C149.69 93.988 149.682 93.9888 149.677 93.9896L127.892 96.2247C127.483 96.2665 127.185 96.6328 127.227 97.041C127.269 97.445 127.626 97.7401 128.031 97.7057C128.035 97.7057 128.039 97.7057 128.044 97.7049L149.829 95.4698C150.238 95.428 150.536 95.0625 150.493 94.6535C150.452 94.2494 150.094 93.9544 149.69 93.988Z"
                fill="#2D2D2D"
              />
              <path
                id="Fill 54"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M116.701 115.822C116.31 115.688 115.889 115.896 115.754 116.283C113.616 122.482 108.916 126.133 103.178 126.05C97.0393 125.96 92.4311 121.883 89.9535 117.15C94.5822 115.729 94.9473 110.839 94.9415 109.293C94.9407 109.033 94.7299 108.826 94.469 108.838C92.7379 108.922 86.3634 109.396 80.3499 111.93C80.0439 112.059 79.9372 112.442 80.1308 112.711C81.0973 114.05 83.9473 117.466 87.8648 117.478C88.3759 121.9 87.0115 126.157 84.0729 128.867C81.4755 131.261 78.134 131.889 74.9057 130.59C74.5234 130.437 74.0902 130.621 73.9368 131.002C73.7834 131.383 73.968 131.817 74.3495 131.97C75.9173 132.601 77.5072 132.845 79.0471 132.715C81.2244 132.531 83.3042 131.6 85.0828 129.96C87.9181 127.347 89.449 123.47 89.458 119.319C92.5952 124.305 97.6636 127.457 103.155 127.537C109.568 127.635 114.805 123.605 117.162 116.768C117.297 116.379 117.09 115.956 116.701 115.822Z"
                fill="#2D2D2D"
              />
              <path
                id="Fill 56"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M104.485 100.304C105.938 100.143 106.985 98.8359 106.825 97.3844C106.663 95.9337 105.356 94.8879 103.903 95.0485C102.451 95.2092 101.404 96.5156 101.563 97.9663C101.725 99.4178 103.032 100.464 104.485 100.304Z"
                fill="#2D2D2D"
              />
              <path
                id="Fill 58"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M74.2331 103.712C74.2339 103.393 74.0321 103.109 73.7302 103.006L59.1828 98.0139C58.7915 97.8803 58.3698 98.0877 58.2369 98.4762C58.1032 98.8647 58.3107 99.2884 58.6988 99.422L71.1754 103.703L59.3937 107.67C59.0048 107.801 58.7948 108.223 58.926 108.612C59.0376 108.944 59.36 109.145 59.6939 109.116C59.753 109.111 59.8112 109.099 59.8695 109.08L73.7261 104.414C74.0288 104.313 74.2314 104.031 74.2331 103.712Z"
                fill="#2D2D2D"
              />
              <path
                id="Fill 60"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M21.3456 151.532C21.4547 151.598 21.5589 151.683 21.6745 151.726C21.9362 151.822 22.2513 152.009 22.4588 151.956C22.8321 151.862 23.1578 151.636 23.4737 151.431C23.6295 151.329 23.6328 151.132 23.5221 150.939C23.2399 150.444 22.965 149.945 22.6762 149.451C22.5187 149.183 22.3112 149.095 22.0232 149.171C21.8345 149.221 21.6589 149.3 21.4727 149.355C21.2496 149.42 21.0371 149.397 20.8599 149.186C20.0469 148.217 19.7064 147.167 19.8016 146.041C19.8262 145.755 20.0206 145.634 20.3077 145.612C20.4981 145.598 20.6917 145.598 20.8828 145.584C21.1667 145.564 21.2971 145.421 21.2627 145.141C21.2102 144.712 21.1692 144.284 21.1216 143.855C21.0551 143.267 20.9362 143.135 20.3053 143.022C20.0641 142.978 19.8147 142.975 19.5751 142.986C19.4529 142.992 19.3003 143.04 19.2404 143.123C18.9836 143.476 18.6973 143.821 18.5316 144.219C18.0155 145.457 18.169 146.784 18.6587 148.12C19.1608 149.49 19.982 150.686 21.3456 151.532ZM24.1464 142.013C24.3105 142.112 24.4738 142.21 24.6387 142.309C24.9644 142.573 25.3015 142.827 25.6141 143.104C28.4945 145.654 28.9761 149.645 26.6002 152.068C24.2022 154.514 20.1396 154.455 17.0623 151.998C14.8562 150.236 13.811 147.339 14.5477 145.006C14.6601 144.65 14.8037 144.306 14.9341 143.957C15.0186 143.816 15.1031 143.675 15.1876 143.534C15.3616 143.336 15.5355 143.139 15.7078 142.94C17.3035 141.1 20.3422 140.5 22.9593 141.511C23.3588 141.666 23.751 141.845 24.1464 142.013Z"
                fill="#E64B23"
              />
              <path
                id="Fill 62"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M21.3453 151.532C19.9817 150.685 19.1605 149.49 18.6584 148.119C18.1687 146.784 18.0152 145.456 18.5313 144.219C18.697 143.82 18.9833 143.475 19.2401 143.123C19.3 143.04 19.4526 142.992 19.5748 142.986C19.8144 142.975 20.0638 142.978 20.305 143.021C20.9359 143.134 21.0548 143.266 21.1213 143.855C21.1689 144.284 21.2099 144.712 21.2624 145.141C21.2968 145.421 21.1664 145.564 20.8825 145.584C20.6914 145.598 20.4978 145.597 20.3074 145.611C20.0203 145.633 19.8259 145.755 19.8013 146.041C19.7061 147.167 20.0466 148.217 20.8596 149.186C21.0368 149.397 21.2493 149.42 21.4724 149.354C21.6586 149.3 21.8342 149.221 22.0229 149.171C22.3109 149.095 22.5184 149.182 22.6759 149.451C22.9647 149.945 23.2396 150.444 23.5218 150.939C23.6325 151.132 23.6292 151.329 23.4734 151.431C23.1575 151.636 22.8318 151.862 22.4585 151.956C22.251 152.008 21.9359 151.822 21.6742 151.726C21.5586 151.683 21.4544 151.598 21.3453 151.532Z"
                fill="white"
              />
            </g>
          </g>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";

import mainModal from "@/components/modals/mainModal";
import autocompleteModal from "@/components/modals/autocomplete/autocomplete";
import autocompleteInput from "@/components/base/autocomplete/index";

import checkEmail from "@/helpers/utils/emailCheck";

// import en from "element-ui/lib/locale/lang/en";
// import de from "element-ui/lib/locale/lang/de";
// import locale from "element-ui/lib/locale";

// locale.use(en);

function storageAvailable(type) {
  try {
    var storage = window[type],
      x = "__storage_test__";
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  } catch (e) {
    return false;
  }
}

import {
  required,
  requiredIf,
  minLength,
  sameAs
} from "vuelidate/lib/validators";
import axios from "axios";
import moment from "moment";
import $config from "@/helpers/config/index";
import uploadImage from "@/components/forms/uploadImage";

const scrollElementIntoView = (element, behavior = "smooth") => {
  let scrollTop = window.pageYOffset || element.scrollTop;

  const finalOffset = element.getBoundingClientRect().top + scrollTop;

  window.parent.scrollTo({
    top: finalOffset,
    behavior: behavior || "auto"
  });
};

export default {
  name: "create-order-form",
  components: {
    mainModal,
    autocompleteModal,
    autocompleteInput,
    uploadImage
  },
  validations: {
    agree: {
      sameAs: sameAs(() => true)
    },
    request: {
      date: {
        required
      },
      time: {
        required
      },
      service_id: {
        required
      },
      contact: {
        first_name: {
          required
        },
        last_name: {
          required
        },
        email: {
          checkEmail,
          required
        },
        phone: {
          required
        }
      },
      address: {
        required
      }
    }
  },
  data() {
    return {
      options: [
        {
          label: "1 Stunde - €100",
          value: "1 Stunde - €100"
        },
        {
          label: "2 Stunde - €200",
          value: "2 Stunde - €200"
        },
        {
          label: "3 Stunde - €300",
          value: "3 Stunde - €300"
        }
      ],
      show: false,
      showAutocompleteInput: false,
      isAutocompleteInputFocused: false,
      autocompletePrevValue: null,
      autocompleteValue: "",
      images: [],
      imagesIndex: 0,
      files: [],
      isValidPhone: false,
      clearFields: false,
      cantEdit: false,
      timeOptions: {
        current: null,
        data: null
      },
      isSubmitted: false,
      isSubmittedCode: false,
      isIterated: false,
      filledAddressWithError: false,
      view: "main",
      agree: false,
      marketing: false,
      isProfy: false,
      token: {
        access_token: null,
        refresh_token: null,
        expires_in: null
      },
      availableDays: [],
      isVerified: false,
      isError: false,
      locale: null,
      name: null
    };
  },
  computed: {
    ...mapGetters({
      request: "orders/request",
      client: "client/client",
      showAutocomplete: "autocomplete/show",
      services: "services/services",
      addresses: "address/addresses"
    }),
    isValid() {
      return !this.$v.$invalid && this.isValidPhone;
    },
    isValidCode() {
      if (this.request.code && this.request.code.length === 4) {
        return true;
      }

      return false;
    },
    pickerOptions() {
      return {
        firstDayOfWeek: 1,
        disabledDate: time => {
          const hasMatch = this.availableDays.find(item => {
            item = new Date(item);
            item.setHours(0, 0, 0, 0);
            return item.getTime() === time.getTime();
          });

          if (!hasMatch) {
            return true;
          }
        }
      };
    },
    isInvalidAddress() {
      return this.filledAddressWithError && this.isIterated;
    },
    termsOfViews() {
      const link_part1 = this.isProfy
        ? `https://getprofy.de`
        : `https://hilfy.at`;

      const link_part2 = this.isProfy
        ? this.isEN
          ? "general-terms-and-conditions"
          : "agb"
        : this.isEN
        ? "general-terms-and-conditions"
        : "agb";

      return `${link_part1}/${link_part2}`;
    },
    privacyPolicy() {
      const link_part1 = this.isProfy
        ? `https://getprofy.de`
        : `https://hilfy.at`;
      const link_part2 = this.isProfy
        ? this.isEN
          ? "privacy-policy"
          : "datenschutzerklarung"
        : this.isEN
        ? "privacy-policy"
        : "datenschutz";
      //general-terms-and-conditions
      return `${link_part1}/${link_part2}`;
    },
    isEN() {
      return this.locale === "en";
    },
    isMain() {
      return this.show && this.view === "main";
    },
    isVerifyingCode() {
      return this.show && this.view === "verifying";
    },
    isThankUPage() {
      return this.show && this.view === "thanks";
    },
    toCabinetLink() {
      return `/gate?access_token=${this.token.access_token}&refresh_token=${this.token.refresh_token}&expires_in=${this.token.expires_in}`;
    }
  },
  methods: {
    ...mapMutations({
      clearForm: "orders/clearForm",
      clearOrders: "orders/clearOrders",
      setState: "orders/setState",
      setStateAutocomplete: "autocomplete/setState"
    }),
    ...mapActions({
      createRequest: "orders/createRequest",
      ordersImageUpload: "orders/uploadImage",
      getWorkload: "public/getWorkload",
      fetchServices: "services/fetch",

      publicLogin: "landing/login",
      publicSendCode: "landing/sendCode",
      publicVerifyCode: "landing/verifyCode",
      publicCheck: "landing/check",
      register: "landing/register",
      publicCreateRequest: "landing/createRequest",
      publicOrdersImageUpload: "landing/uploadImage",
      addFiles: "landing/addFiles"
    }),
    filesUploaded({ images, files }) {
      this.images = [...images];
      this.files = [...files];

      this.$nextTick(() => {
        this.changeIframeHeight();
      });
    },
    prepareFilesForm(files, id) {
      const fd = new FormData();
      files.forEach(item => {
        fd.append("files[]", item.file);
      });
      fd.append("entity_id", id);

      return fd;
    },
    getPrice(item) {
      return item.extra_price == "0"
        ? ""
        : `+${item.extra_price}%  ${this.$t("forms.toThePrice")}`;
    },
    getAddressById(id) {
      let result;

      this.addresses.forEach(element => {
        if (element.id == id) {
          result = element;
        }
      });

      return result;
    },
    prepareFormData() {
      const time = parseInt(this.request.time.split(":")[0]);
      const date = new Date(this.request.date).setHours(time).valueOf() / 1000;

      const phone = this.request.contact.phone.replace(" ", "");
      this.request.contact.phone = phone;

      return {
        contact: this.request.contact,
        address: this.request.address,

        service_id: this.request.service_id,
        description: this.request.description,

        single: {
          date,
          time_flexible: true
        },
        utm_marks: this.getUTM()
      };
    },
    getUTM() {
      try {
        const url = localStorage.getItem("utmUrl");

        if (url == undefined) return;

        return {
          url,
          inbound_type: "Lead form"
        };
      } catch (err) {
        return {
          url: location.href,
          inbound_type: "Lead form"
        };
      }
    },
    clear() {
      this.clearForm();
      this.images = [];
      this.files = [];
      this.autocompleteValue = "";
      this.cantEdit = false;
      this.isSubmitted = false;
    },
    fill({ autocompleteValue, address }) {
      this.request.address = address;
      this.autocompleteValue = autocompleteValue;
      this.filledAddressWithError = false;
      this.cantEdit = true;
    },
    checkValue(v) {
      this.isValidPhone = v.valid && v.type == "mobile";
    },
    autocompleteInputFocus() {
      this.isAutocompleteInputFocused = true;
      this.isIterated = true;
    },
    clearInput() {
      this.cantEdit = false;
    },
    errorInput() {
      console.log("error");
      // this.cantEdit = false;
      this.filledAddressWithError = true;
      // this.request.address = null;
    },
    resetErrors() {
      this.cantEdit = false;
      this.request.address = null;
    },
    changeTime(v) {
      const date = moment(v).format("YYYY-MM-DD");
      let isMatch = false;

      this.timeOptions.data.forEach(e => {
        if (e.date == date) {
          this.timeOptions.current = e.slots;
          isMatch = true;
        }
      });

      if (!isMatch) this.timeOptions.current = [];
    },
    async loadWorkload(e) {
      const res = await this.getWorkload({
        service_id: e
      });

      this.timeOptions.data = res.data.data;
      this.availableDays = this.timeOptions.data.map(item => item.date);

      this.changeTime(this.request.date || new Date());
    },
    setView(v) {
      this.view = v;
    },
    setToken(v) {
      this.token = { ...v };
    },
    openLink() {
      this.$refs["link"].click();
    },
    async verifyCode() {
      if (this.request.code.length < 4) return;

      try {
        const isOkey = await this._verifyCode();
        if (!isOkey) {
          this.isError = true;
          return;
        }

        this.isError = false;

        const hasAccount = await this._checkIfUserExidt();
        const tokenData = await this._getToken(hasAccount);

        const { status, data } = await this._createOrder(
          tokenData.access_token
        );
        await this._attachFiles(data, tokenData.access_token);

        if (this.files.length > 0) {
          await this.addFiles({
            form: this.prepareFilesForm(this.files, data.data[0].id),
            token: tokenData.access_token
          });
        }
        this.setToken(tokenData);
        this.isVerified = true;
      } catch (err) {
        console.log(err);
      }
    },
    changeView() {
      setTimeout(() => {
        this.setView("thanks");
      }, 150);
    },
    async save() {
      this.$v.$touch();

      if (this.$v.$invalid) return;
      this.isSubmitted = true;

      await this._sendCode();

      setTimeout(() => {
        window.parent.postMessage(
          {
            target: "web-hilfy",
            data: {
              scroll: true
            }
          },
          "*"
        );
        this.setView("verifying");
        this.isSubmitted = false;
      }, 600);
    },
    async _getToken(hasAccount) {
      let data;
      if (hasAccount) {
        data = await this._login();
      } else {
        data = await this._registerUser();
      }

      return data;
    },
    async _sendCode() {
      await this.publicSendCode({
        phone: this.request.contact.phone,
        code: ""
      });
    },
    async _verifyCode() {
      try {
        const response = await this.publicVerifyCode({
          phone: this.request.contact.phone,
          code: this.request.code
        });

        return response.status === 204;
      } catch (err) {
        return false;
      }
    },
    async _checkIfUserExidt() {
      const response = await this.publicCheck({
        phone: this.request.contact.phone,
        code: this.request.code
      });

      return response.data.exists;
    },
    async _login() {
      const response = await this.publicLogin({
        phone: this.request.contact.phone,
        code: this.request.code
      });

      return response.data;
    },
    async _registerUser() {
      const response = await this.register({
        first_name: this.request.contact.first_name,
        last_name: this.request.contact.last_name,
        email: this.request.contact.email,
        phone: this.request.contact.phone,
        is_company: false,
        type_app: "web_client"
      });
      return response.data;
    },
    async _createOrder(token) {
      return await this.publicCreateRequest({
        form: this.prepareFormData(),
        token
      });
    },
    async _attachFiles(data, token) {
      this.images.forEach(async item => {
        const res = await this.publicOrdersImageUpload({
          id: data.data[0].id,
          form: item.file,
          token
        });
      });
    },
    changeIframeHeight() {
      if (!this.$refs["main-form"]) {
        return;
      }

      window.parent.postMessage(
        {
          target: "web-hilfy",
          data: {
            height: this.$refs["main-form"].scrollHeight + 50
          }
        },
        "*"
      );
    }
  },
  async mounted() {
    const [name, locale] = window.name.split("_");
    this.locale = locale;
    this.name = name;
    this.$i18n.locale = this.locale;

    this.request.contact = {
      email: "",
      phone: "",
      last_name: "",
      first_name: "",
      confirmed: true
    };

    await this.fetchServices();
    if (this.services[0]) {
      this.loadWorkload(this.services[0].value);
    }

    this.show = true;

    setTimeout(() => {
      this.changeIframeHeight();
      this.isProfy = this.name === "profy" ? true : false;
    }, 200);
    window.addEventListener("resize", this.changeIframeHeight);
  },
  beforeDestroy() {
    this.clear();
  }
};
</script>

<style lang="scss">
.loader {
  font-size: 10px;
  // margin: 50px auto;
  text-indent: -9999em;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #ffffff;
  background: -moz-linear-gradient(
    left,
    #ffffff 10%,
    rgba(255, 255, 255, 0) 42%
  );
  background: -webkit-linear-gradient(
    left,
    #ffffff 10%,
    rgba(255, 255, 255, 0) 42%
  );
  background: -o-linear-gradient(left, #ffffff 10%, rgba(255, 255, 255, 0) 42%);
  background: -ms-linear-gradient(
    left,
    #ffffff 10%,
    rgba(255, 255, 255, 0) 42%
  );
  background: linear-gradient(
    to right,
    #ffffff 10%,
    rgba(255, 255, 255, 0) 42%
  );
  position: relative;
  -webkit-animation: load3 1.2s infinite linear;
  animation: load3 1.2s infinite linear;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  margin-right: 16px;
}

.loader:before {
  width: 50%;
  height: 50%;
  background: #ffffff;
  border-radius: 100% 0 0 0;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
}

.loader:after {
  background: #9bcd82;
  width: 75%;
  height: 75%;
  border-radius: 50%;
  content: "";
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

@-webkit-keyframes load3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes load3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

.btn:hover .loader:after {
  background: #5d5d5d;
}

.btn_disabled .loader:after,
.btn_disabled:hover .loader:after {
  background: #9bcd82 !important;
}
body {
  div,
  .el-input,
  select {
    font-family: "SFUIDisplay-Regular" !important;
  }
}

.public-order {
  min-height: 700px;
  display: flex;
  align-items: center;

  &_form {
    border-radius: 16px;
    border: 3px solid rgb(240, 115, 0);
    padding: 25px 50px;
  }

  .form-item__checkbox-label:before {
    border: 2px solid rgb(240, 115, 0) !important;
  }

  .form-item__checkbox:checked + .form-item__checkbox-label:before {
    background-color: rgb(240, 115, 0) !important;
  }

  .form-item__checkbox-label_error:before {
    border: 2px solid #ca1515 !important;
  }

  &__btn {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.thank-you {
  height: 800px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 20px;
  border-radius: 16px;

  &__title {
    font-size: 24px;
    margin-bottom: 16px;
  }

  &__text {
    margin-bottom: 24px;
    max-width: 90%;
  }

  &__img {
    margin-top: 24px;
  }

  &__link {
    a {
      width: 100%;
      max-width: 266px;
      height: 40px;
      background-color: #9bcd82;
      display: flex;
      justify-content: center;
      align-items: center;
      text-decoration: none;
      color: #000;
      border-radius: 4px;
    }
  }
}

.images {
  display: flex;
  flex-wrap: wrap;

  img {
    object-fit: cover;
  }

  &__container {
    display: flex;
    align-items: center;
    max-width: 370px;
    margin: 0 auto;

    &_adaptive {
      flex-direction: column;
      width: 100%;

      .images__img {
        margin-right: 0;
      }

      .images__title {
        margin-top: 6px;
        text-align: center;
      }

      .images__content {
        width: 100%;
      }
    }
  }

  &__btn {
    border: 1px dashed #f07300;
    width: 100%;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    transition: all 0.3s ease-out;
    cursor: pointer;
    margin-bottom: 0;

    &_adaptive {
      width: 120px;
    }

    &:hover {
      border: 1.04133px dashed #f07300c7;
      background-color: #f07300c7;
      color: #000;

      // .paintable-phone {
      //     fill: #f0730000 !important;
      // }

      // .paintable {
      //     stroke: #000 !important;
      // }

      .images__title {
        color: #fff;
      }

      .images__content {
        color: #fff;
      }
    }
  }

  &__item {
    position: relative;
    &_delete {
      position: absolute;
      right: 6px;
      top: 6px;
      color: #000;
    }
  }

  &__img {
    width: 60px;
    height: 60px;
    display: inline-block;
    margin-right: 22px;
  }

  &__content {
    width: calc(100% - 90px);
    line-height: 15px;
    font-size: 12px;
    color: #828282;
    transition: color 0.3s ease-out;

    &-text_adaptive {
      display: none;
    }
  }

  &__title {
    font-size: 12px;
    line-height: 18px;
    color: #f07300;
    display: block;
    transition: color 0.3s ease-out;
  }
}

.order-modal__btn {
  max-width: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  text-align: center;
  max-width: 100%;
  -webkit-appearance: none;
  appearance: none;
}

@media (max-width: 768px) {
  .images__btn {
    order: 9999;
  }
}

@media (max-width: 568px) {
  .public-order {
    &_form {
      padding: 16px 10px;
    }
  }

  .images__item {
    position: relative;
    margin-right: 12px;
    margin-left: 0;
  }
}

.address-knife {
  &__error {
    font-size: 12px;
    margin-left: 12px;
    color: #bd1515;
  }
}
</style>

<style>
body {
  background-color: unset !important;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100% !important;
}

.form_order .el-select {
  width: 100% !important;
}

.form_createOrder #autocomplete {
  width: 100%;
  max-width: 580px;
  padding: 0 15px;
  box-sizing: border-box;
  position: absolute;
  top: 0%;
  left: 0;
}

.address-knife .el-input--suffix .el-input__inner {
  border: 2px solid #bd1515;
}

.address-knife .autocomplete__input {
  border: 2px solid #bd1515;
}
</style>

<style>
.el-select-dropdown__list .selected {
  background: rgba(155, 205, 130, 0.2) !important;
  color: #000 !important;
}

.el-select-dropdown__list .selected::after {
  position: absolute;
  content: "";
  background-image: url(~@/assets/images/check.svg);
  background-position: center;
  background-repeat: no-repeat;
  width: 24px;
  height: 24px;
  right: 16px;
  top: 0;
  bottom: 0;
  margin: auto;
}

.el-select-dropdown {
  border-radius: 10px;
}

.el-select-dropdown__list {
  padding: 0 !important;
}

.el-select-dropdown__item {
  height: 32px;
}
</style>
